<template>
  <div class="coursePlayBox">
    <div class="videoBox">
      <div
        class="showBuy"
        v-if="showBuy"
      >
        <span
          class="buy"
          @click="buy"
        >开通会员</span>
        <!-- <span class="buy" @click="buy">¥{{ sellingprice }}购买</span> -->
      </div>
      <div
        class="tryseeBox"
        v-else
      >
        <div
          class="videoBox"
          v-if="playInfo"
        >
          <CourseVideo
            :playInfo="playInfo"
            v-on:opation="opation"
          ></CourseVideo>
        </div>
        <div
          class="posterBox"
          v-else
        >
          <img
            :src="info.image"
            alt
          />
        </div>
      </div>
    </div>
    <div
      class="directoryBox"
      v-if="info"
    >
      <div class="courseDirectory">
        <div class="directoryTop">
          <div class="topContent">
            <span
              class="sort"
              @click="sortDirectory()"
            >
              <em>{{ sort == "desc" ? "降序" : "升序" }}</em>
              <i :class="sort == 'desc' ? 'desc' : ''"></i>
            </span>
          </div>
        </div>
        <ul class="listBox1">
          <li
            v-for="(item, index) in info.chapters"
            :key="index"
            @click="showList(index)"
          >
            <p :class="['title', { active: listBox2Status[index] }]">
              <span class="ellipsis">{{ index + 1 + "." + item.name }}</span>
            </p>
            <ul
              class="listBox2"
              v-if="listBox2Status[index]"
            >
              <li
                v-for="(item1, index1) in item.lessons"
                :key="index1"
                @click.stop="getSourse(2, item1)"
                :class="playInfo.lessonid == item1.lessonid ? 'active' : ''"
              >
                <div class="playBox">
                  <div
                    class="soundBox"
                    v-if="playInfo.lessonid == item1.lessonid"
                  >
                    <div class="li1 li"></div>
                    <div class="li2 li"></div>
                    <div class="li3 li"></div>
                    <div class="li4 li"></div>
                  </div>
                  <i
                    v-else
                    :class="[
                      'play',
                      info.customercourse != 'Y' && item1.vip=='Y'
                        ? 'lock'
                        : '',
                    ]"
                  ></i>
                </div>
                <div class="nameBox">
                  <div class="info">
                    <p class="name ellipsis">{{ item1.name }}</p>
                    <p class="time ellipsis">
                      <span>时长 {{ util.formatSeconds(item1.timelength) }}</span>
                      /
                      <span>{{ util.showCount(item1.vplaycount) }} 人学过</span>
                    </p>
                  </div>
                  <div
                    class="opation"
                    v-if="info.customercourse != 'Y'"
                  >
                    <span
                      class="trysee"
                      v-if="item1.needLogin"
                    >试看</span>
                    <i v-else></i>
                  </div>
                  <div
                    v-else
                    class="studyProgress"
                  >
                    <span>{{
                        item1.lessonsstudyfinish == "Y" ? "已学完" : "已学"
                      }}
                      <em v-if="item1.lessonsstudyfinish != 'Y'">{{
                        item1.lessonstudypercent + "%"
                      }}</em></span>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import CourseVideo from "@/components/courseVideo";
import Directory from "./components/courseDirectory";

export default {
  metaInfo() {
    return {
      title: this.info.name,
    };
  },
  data() {
    return {
      info: "",
      showBuy: false,
      playInfo: "",
      listBox2Status: [],
      sort: "asc",
      sellingprice: "",

      vipInfo: "",
    };
  },
  components: {
    Directory,
    CourseVideo,
  },
  mounted() {
    this.courseid = this.$route.query.courseid
      ? this.$route.query.courseid
      : "";
    this.getInfo();
  },
  methods: {
    showList(index) {
      var status = this.listBox2Status[index] ? false : true;
      this.$set(this.listBox2Status, index, status);
    },
    sortDirectory() {
      if (this.info && this.info.chapters) {
        this.info.chapters.reverse();
        this.sort = this.sort == "asc" ? "desc" : "asc";
      }
    },
    getInfo() {
      var url = "iart-api-scm/api/scm/course/queryByCourse";
      var obj = { courseid: this.courseid };
      this.$post(url, obj).then((res) => {
        if (res.code == 1) {
          this.info = res.data;
          this.sellingprice =
            this.info.coursepricedtoes &&
            this.info.coursepricedtoes[0].sellingprice;
          //   this.shareLink();
          var type = this.$route.query.type;
          var item = this.$route.query.item
            ? JSON.parse(this.$route.query.item)
            : "";
          this.listBox2Status = this.$route.query.listBox2Status
            ? JSON.parse(this.$route.query.listBox2Status)
            : [];
          this.getSourse(type, item);
          this.getVip();
          if (this.util.loginStatus()) {
            this.playLessionid = res.data.newlessonid;
          }
        } else {
          this.util.toast({ msg: res.message });
        }
      });
    },
    getVip() {
      var obj = {
        businesstype: 1018,
        lclasscode: this.info.lclasscode,
        mclasscode: this.info.mclasscode,
        sclasscode: this.info.sclasscode,
      };
      this.$post("iart-api-crm/api/crm/custservice/queryCustVipAd", obj).then(
        (res) => {
          if (res.code == 1) {
            if (res.data.rtncode == 1) {
              this.vipInfo = res.data;
            }
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      );
    },
    getSourse(type, item) {
      var obj = {};
      if (type == 1) {
        obj.trysee = "Y";
        obj.courseid = this.info.courseid;
      } else {
        if (this.info.customercourse != "Y") {
          if (item.needLogin) {
            obj.trysee = "Y";
            obj.lessonid = item.lessonid;
            this.showBuy = false;
          } else {
            this.showBuy = true;
            this.playInfo = "";
            return false;
          }
        } else {
          obj.lessonid = item.lessonid || this.$route.query.lessonid;
          obj.courseid = this.info.courseid;
        }
      }
      this.$post("/iart-api-scm/api/scm/lesson/queryVideoByLesson", obj).then(
        (res) => {
          if (this.util.processingData(res)) {
            if (res.code == 1) {
              if (res.data && res.data[0]) {
                this.playInfo = res.data[0];
                if (obj.trysee == "Y") {
                  this.playInfo.trysee = true;
                }
                this.playInfo.customercourse = this.info.customercourse;
                var chapters = this.info.chapters;
                this.playInfo.chaptersLength = chapters.length;
                for (var i = 0; i < chapters.length; i++) {
                  if (this.playInfo.chapterid == chapters[i].chapterid) {
                    this.playInfo.playChapters = i;
                    this.listBox2Status[i] = true;
                    var lessons = chapters[i].lessons;
                    this.playInfo.lessonsLength = lessons.length;
                    for (var j = 0; j < lessons.length; j++) {
                      if (this.playInfo.lessonid == lessons[j].lessonid) {
                        this.playInfo.playLesson = j;
                        break;
                      }
                    }
                  }
                }
              } else {
                this.util.toast({ msg: "暂无视频资源" });
              }
            } else {
              this.util.toast({ msg: res.message });
            }
          }
        }
      );
    },
    opation(data) {
      var item = "";
      var chapters = this.info.chapters;
      if (data.type == "prev") {
        if (data.playLesson == 0) {
          item =
            chapters[data.playChapters - 1].lessons[
              chapters[data.playChapters - 1].lessons.length - 1
            ];
        } else {
          item = chapters[data.playChapters].lessons[data.playLesson - 1];
        }
      } else {
        if (chapters[data.playChapters].lessons.length == data.playLesson) {
          item = chapters[data.playChapters + 1].lessons[0];
        } else {
          item = chapters[data.playChapters].lessons[data.playLesson + 1];
        }
      }
      this.getSourse(2, item);
    },
    buy() {
      var info = this.info;
      if (!this.util.loginStatus()) {
        this.util.wechatLogin();
        return false;
      }
      if (info.customercourse == "Y") {
        var obj = {};
        obj.lessonid = this.playLessionid
          ? this.playLessionid
          : info.chapters[0].lessons[0].lessonid;
        this.getSourseInfo = { type: 2, data: obj };
      } else {
        if (this.sellingprice > 0) {
          this.$router.push({
            path: "/h5/index/vip/sVipDetail",
            query: {
              certificaruleid: this.vipInfo.parentidruleid,
            },
          });
          /*  this.$router.push({
            path: "/h5/common/order",
            query: {
              ordertype: 1000,
              productid: this.info.coursepricedtoes[0].productid,
            },
          }); */
        } else {
          this.freeObj = {
            ordertype: 1000,
            buyNum: 1,
            productid: this.info.coursepricedtoes[0].productid,
          };
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.coursePlayBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  min-height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  .videoBox {
    display: inline-block;
    width: 100%;
    height: 34vh;
    .tryseeBox,
    .showBuy {
      width: 100%;
      height: 100%;
    }
    .tryseeBox {
      position: relative;
      .videoBox,
      .posterBox {
        width: 100%;
        height: 100%;
        position: relative;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .showBuy {
      width: 100%;
      height: 100%;
      background: #000000;
      display: flex;
      align-items: center;
      justify-content: center;
      .buy {
        display: inline-block;
        width: 88px;
        text-align: center;
        border-radius: 4px;
        color: #ffffff;
        font-size: 13px;
        line-height: 30px;
        height: 30px;
        background: rgba(216, 216, 216, 0.2);
      }
    }
  }
  .directoryBox {
    flex: 1;
    overflow: auto;
    padding: 28px 16px 0;
    .courseDirectory {
      .directoryTop {
        text-align: right;
        .topContent {
          span {
            font-size: 14px;
            line-height: 24px;
            color: rgba(45, 45, 45, 0.85);
            em {
              margin-left: 4px;
              font-weight: normal;
              vertical-align: middle;
            }
            i {
              vertical-align: middle;
            }
          }
          .sort {
            i {
              display: inline-block;
              width: 24px;
              height: 24px;
              background: url(../../../assets/img/h5/asc.png) no-repeat;
              background-size: 24px 24px;
              transform: rotate(0);
              transition: all linear 0.2s;
            }
            .desc {
              transform: rotate(180deg);
              transition: all linear 0.2s;
            }
          }
        }
      }
      .listBox1 {
        margin-top: 8px;
        > li {
          padding: 16px 0;
          > p {
            font-size: 16px;
            color: rgba(53, 54, 60, 1);
            line-height: 24px;
            span {
              padding: 0 40px 0 11px;
              display: block;
              position: relative;
            }
          }
          > p span::after {
            content: " ";
            display: inline-block;
            width: 3px;
            background: rgba(53, 54, 60, 0.14);
            position: absolute;
            left: 0;
            top: 4px;
            bottom: 4px;
          }
          > p span::before {
            content: " ";
            display: inline-block;
            width: 24px;
            height: 24px;
            background: url(../../../assets/img/h5/arrow_r_darkgray.png)
              no-repeat;
            background-size: 24px 24px;
            transform: rotate(90deg);
            position: absolute;
            right: 0;
            top: 50%;
            margin-top: -12px;
            transition: all 0.3s linear;
          }
          > p.active {
            padding-bottom: 0;
            span::before {
              transition: all 0.3s linear;
              transform: rotate(-90deg);
            }
          }
          ul {
            margin-top: 16px;
            background: rgba(244, 244, 247, 1);
            border-radius: 3px;
            li {
              display: flex;
              flex-direction: row;
              align-items: center;
              padding-top: 16px;
              .playBox {
                margin-left: 16px;
                padding-bottom: 16px;
                .soundBox {
                  width: 16px;
                  height: 16px;
                  margin: 0 auto;
                  overflow: hidden;
                  .li {
                    width: 14%;
                    float: left;
                    height: 114%;
                    position: relative;
                  }
                  .li:not(:last-child) {
                    margin-right: 14%;
                  }
                  .li::before {
                    content: " ";
                    position: absolute;
                    left: 0;
                    right: 0;
                    bottom: -14%;
                    background: #db1a1f;
                    border-radius: 14%;
                  }
                  .li1::before {
                    top: 60%;
                    animation: li1Active 1s linear infinite;
                  }
                  .li2::before {
                    top: 20%;
                    animation: li2Active 1s linear infinite;
                  }
                  .li3::before {
                    top: 80%;
                    animation: li3Active 1s linear infinite;
                  }
                  .li4::before {
                    top: 40%;
                    animation: li4Active 1s linear infinite;
                  }
                }
                i {
                  display: inline-block;
                  width: 24px;
                  height: 24px;
                }
                .play {
                  background: url(../../../assets/img/h5/play_g.png) no-repeat;
                  background-size: 24px 24px;
                }
                .lock {
                  background: url(../../../assets/img/h5/play_b.png) no-repeat;
                  background-size: 24px 24px;
                }
              }
              .nameBox {
                flex: 1;
                overflow: hidden;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding: 0 16px 16px 0;
                margin-left: 12px;
                .info {
                  flex: 1;
                  overflow: hidden;
                  .name {
                    font-size: 14px;
                    line-height: 20px;
                    color: rgba(53, 54, 60, 1);
                  }
                  .time {
                    font-size: 11px;
                    line-height: 16px;
                    color: rgba(53, 54, 60, 0.4);
                    margin-top: 4px;
                  }
                }
                .opation {
                  margin-left: 12px;
                  width: 49px;
                  text-align: center;
                  .trysee {
                    display: inline-block;
                    font-size: 12px;
                    line-height: 25px;
                    height: 25px;
                    color: rgba(255, 255, 255, 1);
                    background: rgba(73, 66, 72, 1);
                    width: 49px;
                    border-radius: 3px;
                    text-align: center;
                  }
                  i {
                    display: inline-block;
                    width: 24px;
                    height: 24px;
                    background: url(../../../assets/img/h5/lock.png) no-repeat;
                    background-size: 24px 24px;
                  }
                }
                .studyProgress {
                  margin-left: 12px;
                  font-size: 12px;
                  line-height: 17px;
                  color: rgba(53, 54, 60, 0.4);
                }
              }
            }
            li:not(:last-child) {
              .nameBox {
                border-bottom: 0.5px solid rgba(224, 224, 224, 1);
              }
            }
          }
        }
        > li:not(:last-child) {
          border-bottom: 0.5px dashed rgba(212, 212, 212, 1);
        }
      }
    }
  }
}
@keyframes li1Active {
  20% {
    top: 100%;
  }
  60% {
    top: 20%;
  }
  70% {
    top: 0%;
  }
  100% {
    top: 60%;
  }
}
@keyframes li2Active {
  40% {
    top: 100%;
  }
  90% {
    top: 0%;
  }
  100% {
    top: 20%;
  }
}
@keyframes li3Active {
  10% {
    top: 100%;
  }
  60% {
    top: 0%;
  }
  100% {
    top: 80%;
  }
}
@keyframes li4Active {
  30% {
    top: 100%;
  }
  80% {
    top: 0%;
  }
  100% {
    top: 40%;
  }
}
</style>